import { Button, Grid, Typography } from '@mui/material';
import { DataGrid, esES } from '@mui/x-data-grid';
import { DataGridStyle } from '../../../../../styles/DataGridSytle';
import { useLocation } from 'react-router-dom';
import { numericFormatter } from 'react-number-format';
import { useEffect, useState } from 'react';
import { sendRequest } from '../../../../../services/request';
import * as XLSX from 'xlsx';

export const BDDConsolidada = ({ pais }) => {
    const [rows, setRows] = useState([]);
    const [limit, setLimit] = useState(50);
    const [page, setPage] = useState(0);
    const [rowCount, setRowCount] = useState(null);

    //Loading
    const [loading, setLoading] = useState(false);

    const location = useLocation();
    const URL = process.env.REACT_APP_API_URL;

    const campana = location.state?.campana;

    useEffect(() => {
        setLoading(true);
        const fetchData = async () => {
            try {
                const res = await sendRequest(
                    'get',
                    `${URL}/${pais}/envio?page=${page}&limit=${limit}&campanaId=${campana.id}&estado=7`,
                );
                setRows(res.data.items);
                setRowCount(res.data.meta.totalItems);
                setLoading(false);
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, [URL, pais, page, limit, campana.id]);

    const columns = [
        {
            field: 'cliente',
            headerName: campana.division.id === 1 ? 'Cliente' : 'Donante',
            flex: 1,
            headerClassName: 'header',
            headerAlign: 'center',
            sortable: false,
            valueFormatter: ({ value }) =>
                `${value.nombres} ${value.apellidos ? value.apellidos : ''}`,
            renderCell: ({ row }) =>
                `${row.cliente?.nombres} ${
                    row.cliente.apellidos ? row.cliente.apellidos : ''
                }`,
        },
        {
            field: 'celular',
            headerName: 'Celular',
            headerClassName: 'header',
            headerAlign: 'center',
            sortable: false,
            renderCell: ({ row }) => row.cliente?.celular,
        },
        {
            field: 'correo',
            headerName: 'Correo',
            flex: 1,
            headerClassName: 'header',
            headerAlign: 'center',
            sortable: false,
            renderCell: ({ row }) => row.cliente?.correo,
        },
    ];

    if (campana.con_delivery) {
        const destinoColumn = [
            {
                field: 'destino',
                headerName: 'Destino',
                flex: 1.5,
                headerClassName: 'header',
                headerAlign: 'center',
                sortable: false,
                valueGetter: ({ row }) => row.cliente?.direccion_exacta,
                renderCell: ({ row }) => row.cliente?.direccion_exacta,
            },
        ];
        columns.splice(2, 0, ...destinoColumn);
    }

    if (campana.division.id === 1) {
        const pubColumns = [
            {
                field: 'cantidad',
                headerName: 'Cantidad',
                flex: 'auto',
                headerClassName: 'header',
                editable: true,
                sortable: false,
                headerAlign: 'center',
                align: 'center',
                renderCell: ({ row }) => row.cantidad,
            },
            {
                field: 'medio_pago',
                headerName: 'Medio de Pago',
                flex: 1,
                headerClassName: 'header',
                editable: true,
                sortable: false,
                headerAlign: 'center',
                align: 'center',
                renderCell: ({ row }) => row?.medio_pago?.nombre,
            },
        ];
        columns.splice(!campana.con_delivery ? 3 : 4, 0, ...pubColumns);
    } else if (campana.division.id === 2) {
        const fundColumns = [
            {
                field: 'donacion_total',
                headerName: 'Donación Total',
                flex: 1,
                headerClassName: 'header',
                sortable: false,
                headerAlign: 'center',
                align: 'center',
                renderCell: ({ row }) => {
                    return numericFormatter(row.donacion_total.toString(), {
                        thousandSeparator: true,
                        prefix: pais === 'colombia' ? '$' : 'B/. ',
                        decimalScale: 2,
                        fixedDecimalScale: true,
                    });
                },
            },
            {
                field: 'medio_pago',
                headerName: 'Medio de Pago',
                flex: 1,
                headerClassName: 'header',
                editable: true,
                sortable: false,
                headerAlign: 'center',
                align: 'center',
                renderCell: ({ row }) => row?.medio_pago?.nombre,
            },
        ];
        columns.splice(!campana.con_delivery ? 3 : 4, 0, ...fundColumns);
    }

    const handlePaginationChange = (event) => {
        setPage(event.page);
        setLimit(event.pageSize);
    };

    const handleExportar = () => {
        // Extract data from rows and columns
        const data = rows.map((row) => {
            const dataValue = {
                cliente: `${row.cliente?.nombres || ''} ${
                    row.cliente?.apellidos || ''
                }`,
                celular: row.cliente.celular,
                correo: row.cliente.correo,
                destino: row.cliente?.direccion_exacta,
                cantidad: row.cantidad,
                medio_pago: row.medio_pago?.nombre,
                donacion_total: row.donacion_total,
            };
            if (!campana.con_delivery) {
                delete dataValue.destino;
            }
            if (campana.division.id === 1) {
                delete dataValue.donacion_total;
            }
            if (campana.division.id === 2) {
                delete dataValue.cantidad;
            }
            return { ...dataValue };
        });

        // Create a worksheet
        const worksheet = XLSX.utils.json_to_sheet(data);

        // Create a workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // Export the workbook to an Excel file
        XLSX.writeFile(workbook, `BDDConsolidada_${campana.nombre}.xlsx`);
    };

    return (
        <Grid container>
            <Grid container spacing={5} py={3} pr={3}>
                <Grid item xs={10}>
                    <Typography
                        variant="h4"
                        color="primary"
                        sx={{
                            textAlign: 'start',
                            marginLeft: '10px',
                        }}
                    >
                        Validación BDD y Delivery / BDD Consolidada /{' '}
                        {campana.nombre}
                    </Typography>
                </Grid>
                <Grid item xs={2}>
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={handleExportar}
                    >
                        Exportar a excel
                    </Button>
                </Grid>
            </Grid>
            <Grid container alignItems="center" justifyContent="center">
                <Grid item xs={10}>
                    <DataGrid
                        localeText={
                            esES.components.MuiDataGrid.defaultProps.localeText
                        }
                        disableColumnSelector
                        disableDensitySelector
                        disableColumnFilter
                        disableColumnMenu
                        disableRowSelectionOnClick
                        loading={loading}
                        initialState={{
                            pagination: {
                                paginationModel: { pageSize: limit },
                            },
                        }}
                        rows={rows}
                        columns={columns}
                        paginationMode="server"
                        onPaginationModelChange={handlePaginationChange}
                        rowCount={rowCount ? rowCount : 0}
                        sx={[
                            DataGridStyle,
                            {
                                '& .MuiDataGrid-virtualScroller': {
                                    minHeight: '30vh',
                                },
                            },
                        ]}
                    ></DataGrid>
                </Grid>
            </Grid>
        </Grid>
    );
};
